import axios from 'axios';
import { BASE_URL } from './api';

export async function getTiers(token) {
    return axios({
        method: "get",
        url: `${BASE_URL}/tiers`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => {
        return response.data
    })
    .catch(error => console.error(error))

}